<template>
    <a
        :href="href"
        target="_blank"
        class="inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-indigo-600 transition-colors hover:bg-indigo-50 hover:text-indigo-800"
    >
        {{ t("vue.kiosk_da_admin") }}
        <ArrowTopRightOnSquareIcon class="h-3 w-3" />
    </a>
</template>

<script lang="ts" setup>
import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

defineProps<{ href: string }>();
</script>
